module.exports = __webpack_public_path__ + "media/images/icons/192-756179fa9f9ad768a80bf9c7f21ff5e2.png";